export const DropdownContentActionTypes = {
  ADD_ALL_USER_STATES: 'ADD_ALL_USER_STATES',
  ADD_ALL_USER_COUNTRIES: 'ADD_ALL_USER_COUNTRIES',
  ADD_ALL_USER_INDUSTRIES: 'ADD_ALL_USER_INDUSTRIES',
  ADD_ALL_INDUSTRIES: 'ADD_ALL_INDUSTRIES',
  ADD_ALL_LOCATIONS: 'ADD_ALL_LOCATIONS',
  ADD_ALL_RESOURCE_TYPES: 'ADD_ALL_RESOURCE_TYPES',
  ADD_ALL_SOFTWARES: 'ADD_ALL_SOFTWARES',
};
